<svelte:options customElement="state-dropdown" />

<script>
    import { Theme } from "@urbaninstitute/dataviz-components";
    import Dropdown from "./Dropdown/Dropdown.svelte";
    import state_urls from "../data/state_urls.json";

    export let state = null;

    const dropdownData = state_urls.map((d) => ({
        label: d.state_name,
        value: d.state_url,
        disabled: d.disabled,
    })).sort((a, b) => a.label.localeCompare(b.label));

    /** @type { string } */
    let selectedUrl = state ? getUrlByState(state) : null;

    function getUrlByState(stateName) {
        return (
            state_urls.find((d) => d.state_name == stateName)?.state_url || null
        );
    }

    function goToState() {
        window.location.href = selectedUrl;
    }
</script>

<Theme>
    <div class="wrapper">
        <span class="dropdown-text"><slot /></span>
        <Dropdown
            id="dropdown"
            variant="primary"
            data={dropdownData}
            inlineLabel="Dropdown"
            bind:value={selectedUrl}
            on:change={goToState}
            placeholder={null}
        />
    </div>
</Theme>

<style>
    .wrapper {
        /* display: flex; */
        /* align-items: center; */
        /* gap: 1.5rem; */
        font-size: var(--font-size-4xl);
    }
    .dropdown-text {
        font-weight: var(--font-weight-bold);
    }
    /* make dropdowns sit inline */
    .wrapper :global(.dropdown-parent) {
        display: inline-block !important;
        padding: 0 !important;
        transform: translateY(-1px) !important;
    }
    .wrapper :global(.dropdown-container) {
        width: fit-content !important;
    }
    .wrapper :global(.dropdown-container select) {
        color: var(--color-gray-shade-darkest) !important;
        padding-right: var(--spacing-10) !important;
        font-size: var(--font-size-4xl) !important;
        font-style: italic;
        background-color: transparent !important;
        border-color: transparent !important;
        border-bottom: 5px solid var(--color-blue) !important;
        padding: 0 !important;
        padding-right: var(--spacing-8) !important;
    }
    .wrapper :global(.dropdown-container option) {
        font-size: var(--font-size-normal) !important;
    }

    .wrapper :global(.dropdown-container .icons) {
        padding-right: var(--spacing-1) !important;
        transform: translateY(-1rem);
    }
</style>
